import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query EventClassifications($page: Int, $perPage: Int, $search: String) {
    EventClassifications(page: $page, perPage: $perPage, search: $search) {
      items {
        id
        title
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  title: string;
}

export interface GetAllGql {
  EventClassifications: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
